import { mutationFor } from "@visioni/a3s-client-api/app";
import { createConfirmedDumpEndpoint } from "../client-messages/confirmed-dumps";

export const createConfirmedDumpMutation = mutationFor(createConfirmedDumpEndpoint);
